/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import {
	ToggleControl,
	SelectControl,
} from '@wordpress/components';
import { FontSizePicker } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import blockConst from '../constants';
import { updateBlockStyle } from '../inline-styles';

const { hookPrefix } = blockConst;

const tagLists = [
	{ label: 'Heading 1', value: 'h1' },
	{ label: 'Heading 2', value: 'h2' },
	{ label: 'Heading 3', value: 'h3' },
	{ label: 'Heading 4', value: 'h4' },
	{ label: 'Heading 5', value: 'h5' },
	{ label: 'Heading 6', value: 'h6' },
	{ label: 'DIV', value: 'div' },
	{ label: 'P', value: 'p' },
];
addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const {
			displayPrefix,
			displaySuffix,
			prefixFontSize,
			prefixTag,
			titleTag,
			titleFontSize,
			suffixTag,
			suffixFontSize,
		} = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion
					tabs={ [
						{
							name: 'prefix-title',
							initialOpen: true,
							label: () => {
								return __( 'Prefix Title' );
							},
							cb: () => {
								return (
									<>

										<ToggleControl
											label={ __( 'Display prefix', 'gutenify' ) }
											checked={ displayPrefix }
											help={
												displayPrefix
													? __( 'Showing the prefix.', 'gutenify' )
													: __( 'Toggle to show the prefix.', 'gutenify' )
											}
											onChange={ () =>
												setAttributes( { displayPrefix: ! displayPrefix } )
											}
										/>

										{ displayPrefix && (
											<>
												<SelectControl
													label={ __( 'Prefix Title Tag' ) }
													value={ prefixTag }
													options={ tagLists }
													onChange={ ( tag ) => setAttributes( { prefixTag: tag } ) }
												/>
												<FontSizePicker
													onChange={ ( size ) => {
														const data = {
															prefixFontSize: size,
														};
														setAttributes( data );
														updateBlockStyle( data, props );
													} }
													value={ prefixFontSize }
													withReset={ true }
												/>
											</>
										) }
									</>
								);
							},
						},
						{
							name: 'title',
							initialOpen: true,
							label: () => {
								return __( 'Main Title' );
							},
							cb: () => {
								return (
									<>

										<SelectControl
											label={ __( 'Title Tag' ) }
											value={ titleTag }
											options={ tagLists }
											onChange={ ( tag ) => setAttributes( { titleTag: tag } ) }
										/>
										<FontSizePicker
											onChange={ ( size ) => {
												const data = {
													titleFontSize: size,
												};
												setAttributes( data );
												updateBlockStyle( data, props );
											} }
											value={ titleFontSize }
											withReset={ true }
										/>

									</>
								);
							},
						},

						{
							name: 'suffix-title',
							initialOpen: true,
							label: () => {
								return __( 'Suffix Title' );
							},
							cb: () => {
								return (
									<>

										<ToggleControl
											label={ __( 'Display suffix', 'gutenify' ) }
											checked={ displaySuffix }
											help={
												displaySuffix
													? __( 'Showing the suffix.', 'gutenify' )
													: __( 'Toggle to show the suffix.', 'gutenify' )
											}
											onChange={ () =>
												setAttributes( { displaySuffix: ! displaySuffix } )
											}
										/>

										{ displaySuffix && (
											<>
												<SelectControl
													label={ __( 'Suffix Title Tag' ) }
													value={ suffixTag }
													options={ tagLists }
													onChange={ ( tag ) => setAttributes( { suffixTag: tag } ) }
												/>
												<FontSizePicker
													onChange={ ( size ) => {
														const data = {
															suffixFontSize: size,
														};
														setAttributes( data );
														updateBlockStyle( data, props );
													} }
													value={ suffixFontSize }
													withReset={ true }
												/>
											</>
										) }
									</>
								);
							},
						},
					] }
				/>
			</Fragment>,
		];
	}
);
